import React, { useState, useEffect } from "react";
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner";
import NavbarFixed from "../components/Navbar-Fixed.js";
import Wallet from "../components/WalletNew";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";



export default function WalletPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>
    
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <Wallet />
        </div>
      </div>
      {/* <FooterNew/> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
